import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import Dashboard from "../screens/auth/Dashboard";
import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Booking from "../screens/auth/Booking";
import Profile from "../screens/auth/Profile";
import Blog from "../screens/users/Blog";
import ServiceDetails from "../components/User/Service/ServiceDetails";
import Industries from "../screens/users/Industries";
import ServiceDetailsPage from "../components/User/Service/ServiceDetails";
import IndustryDetails from "../components/User/Industries/IndustryDetails";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/bookings",
    component: <Booking />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
];

export const nonAuthRoutes = [
  // {
  //   path: "/login",
  //   component: <Login />,
  // },
  {
    path: "/register",
    component: <Register />,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/blog",
    component: <Blog />,
  },
  {
    path: "/industries",
    component: <Industries />,
  },
  {
    path: "/industries/:slug",
    component: <IndustryDetails />,
  },
  {
    path: "/services",
    component: <ServiceDetails />,
  },
  {
    path: "/services/:serviceSlug",
    component: <ServiceDetails />,
  },
  {
    path: "/services/:serviceSlug/:subSlug",
    component: <ServiceDetails />,
  },
];
